export default __webpack_public_path__ + "static/media/gardenofeden1440x1176.c7af1ea5.jpg";